require("core-js/modules/es.array.reduce.js");

var type = function type(s) {
  return Object.prototype.toString.call(s).slice(8, -1).toLowerCase();
};

var types = ["String", "Array", "Undefined", "Boolean", "Number", "Function", "Symbol", "Object"];
module.exports = types.reduce(function (acc, str) {
  acc["is" + str] = function (val) {
    return type(val) === str.toLowerCase();
  };

  return acc;
}, {});